module.exports = __webpack_public_path__ + "img/h5-进阶能力.6f2f0c52.svg";